import { render } from "./result.vue?vue&type=template&id=3184753c&scoped=true"
const script = {}

import "./result.vue?vue&type=style&index=0&id=3184753c&lang=less"
import "./result.vue?vue&type=style&index=1&id=3184753c&lang=less&scoped=true"

import exportComponent from "/Users/lily/Documents/7pa/qpyx-super-webstore/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3184753c"]])

export default __exports__